/* import __COLOCATED_TEMPLATE__ from './finish-timing-record-table.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { use } from 'ember-resources';
import { socketRecordTable } from 'bullitttime-embercomponents/utils/socket-record-table-resource';

export default class FinishTimingAssociationTableComponent extends Component
{
	@tracked timingRecordForContextMenu = null;

	@service ajax;
	@service socketGuru;

	// Rebuilds whenever a tracked read in this thunk changes (here, @event).
	@use finishRecords = socketRecordTable(() =>
	{
		const { event } = this.args;
		return {
			socketGuru: this.socketGuru,
			ajax: this.ajax,
			channels: 'finishAssociationRecord',
			endpoint: () => event ? `/events/${event.id}/finishAssociationRecords` : null,
			transform: (record) => this.transformRecord(record),
			sort: this.sortFn,
		};
	});

	transformRecord(record)
	{
		if(!this.args.event || record.eventId != this.args.event.id)
		{
			return null;
		}
		record.color = this.recordColor(record);
		return record;
	}

	sortFn(a,b)
	{
		let aTime = null;
		if(a.finishImpulseTime)
		{
			aTime = a.finishImpulseTime;
		}
		else if(a.finishPlungerImpulseTime)
		{
			aTime = a.finishPlungerImpulseTime
		}
		else if(a.entryTime)
		{
			aTime = a.entryTime;
		}

		let bTime = null;
		if(b.finishImpulseTime)
		{
			bTime = b.finishImpulseTime;
		}
		else if(b.finishPlungerImpulseTime)
		{
			bTime = b.finishPlungerImpulseTime
		}
		else if(b.entryTime)
		{
			bTime = b.entryTime;
		}

		a.sortTime = aTime;
		b.sortTime = bTime;

		return aTime>bTime ? -1 : aTime<bTime ? 1 : (a.id>b.id?1:-1) ;
	}

	recordColor(record)
	{
		if(record.participatesInAutoAssociation == false)
		{
			return "table-warning";
		}
		if(record.isPosted == true)
		{
			return "table-info";
		}
	}

	@action
	click()
	{
		this.timingRecordForContextMenu = null;
		const menu = document.getElementById("context-menu");
		menu.style.display = "none";
		menu.classList.add("hide");
	}

	@action
	finishImpulseClicked(timingRecord)
	{
		if(this.timingRecordForContextMenu == null)
			this.args.finishImpulseSelectAction(timingRecord);
	}
	@action
	finishPlungerImpulseClicked(timingRecord)
	{
		if(this.timingRecordForContextMenu == null)
			this.args.finishPlungerImpulseSelectAction(timingRecord);
	}
	@action
	bibClicked(timingRecord)
	{
		if(this.timingRecordForContextMenu == null)
			this.args.bibRecordSelectedAction(timingRecord);
	}
	@action
	contextMenu(timingRecord,browserEvent)
	{
		browserEvent.preventDefault();

		this.timingRecordForContextMenu = timingRecord;

		const menu = document.getElementById("context-menu");
		menu.querySelector("#auto").classList.toggle("active", timingRecord.participatesInAutoAssociation);
		menu.querySelector("#posted").classList.toggle("active", timingRecord.isPosted);
		menu.querySelector("#clearEntry").classList.toggle("disabled", timingRecord.EntryId == null);
		menu.querySelector("#disassociateBib").classList.toggle("disabled",
			timingRecord.EntryId == null ||
			(timingRecord.finishImpulseId == null && timingRecord.finishPlungerImpulseId == null));
		menu.querySelector("#disassociate").classList.toggle("disabled",
			timingRecord.finishImpulseId == null || timingRecord.finishPlungerImpulseId == null);
		const tableRect = document.getElementById("finishTimingRecordTable").getBoundingClientRect();
		menu.style.display = "block";
		menu.style.top = (browserEvent.clientY - (tableRect.top + window.scrollY) - 20) + "px";
		menu.style.left = (browserEvent.clientX - (tableRect.left + window.scrollX)) + "px";
		menu.classList.add("show");

		return false;
	}

	@action
	contextMenuAuto()
	{
		var tr = this.timingRecordForContextMenu;
		if(tr == null)
		{
			return;
		}
		if(tr.participatesInAutoAssociation)
		{
			this.ajax.request("/finish-timing-records/"+tr.id+"/removeFromAutoAssociation").then(function(response)
			{
				if(response.error != null)
					alert(response.error);
			});
		}
		else
		{
			this.ajax.request("/finish-timing-records/"+tr.id+"/addToAutoAssociation").then(function(response)
			{
				if(response.error != null)
					alert(response.error);
			});
		}
		this.click();
	}

	@action
	contextMenuPosted()
	{
		var tr = this.timingRecordForContextMenu;
		if(tr == null)
		{
			return;
		}
		if(tr.isPosted)
		{
			this.ajax.request("/finish-timing-records/"+tr.id+"/clearPosted").then(function(response)
			{
				if(response.error != null)
					alert(response.error);
			});
		}
		else
		{
			this.ajax.request("/finish-timing-records/"+tr.id+"/setPosted").then(function(response)
			{
				if(response.error != null)
					alert(response.error);
			});
		}
		this.click();
	}

	@action
	contextMenuClearEntry()
	{
		var tr = this.timingRecordForContextMenu;
		if(tr == null)
		{
			return;
		}

		if(tr.EntryId == null)
		{
			return;
		}

		this.ajax.request("/finish-timing-records/"+tr.id+"/clearEntry").then(function(response)
		{
			if(response.error != null)
				alert(response.error);
		});
		this.click();
	}

	@action
	contextMenuDisassociate()
	{
		var tr = this.timingRecordForContextMenu;
		if(tr == null)
		{
			return;
		}

		if(tr.finishImpulseId == null || tr.finishPlungerImpulseId == null)
		{
			return;
		}

		this.ajax.request("/finish-timing-records/"+tr.id+"/disassociateFinishImpulse").then(function(response)
		{
			if(response.error != null)
				alert(response.error);
		});
		this.click();
	}

	@action
	contextMenuDisassociateBib()
	{
		var tr = this.timingRecordForContextMenu;
		if(tr == null)
		{
			return;
		}

		if(tr.EntryId == null ||
			(tr.finishImpulseId == null && tr.finishPlungerImpulseId == null))
		{
			return;
		}

		this.ajax.request("/finish-timing-records/"+tr.id+"/disassociateBibRecord").then(function(response)
		{
			if(response.error != null)
				alert(response.error);
		});
		this.click();
	}
}
